module.exports = __webpack_public_path__ + "media/images/10-6f1ec908.png";